import { getSharedState as o } from "../../utilities/state/index.js";
const r = {
  number: "",
  hours: "",
  companyAddress: void 0
}, t = o("csr", r), c = () => t.get(), S = (e, s) => {
  t.switchContext({ countryCode: e }), t.set(s);
}, T = () => {
  t.reset();
};
export {
  t as CSR_STATE,
  c as getCsr,
  T as resetCsr,
  S as setPhoneInfo
};
//# sourceMappingURL=index2.js.map
